import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
	providedIn: 'root'
})
export class LogsService {

	constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

	loadDataHistory(): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/export/history`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	  }
	  loadDataHistoryLogs(queueID): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/export/getLogs/${queueID}`, this.constantsService.httpCustomOptions)
		  .pipe(
			catchError(this.handleError));
	  }
	  deleteHistory(queueId): Observable<any> {
		return this.http
		  .get(`${this.constantsService.baseAPIURL}/export/history/delete/${queueId}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
		  .pipe(
			catchError(this.handleError));
	  }

	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}

}
